export const downloadFile = (fileName, fileUrl) => {
    if (isMinioUrl(fileUrl)) {
        createMinioLink(fileName, fileUrl);
    } else {
        createNormalLink(fileName, fileUrl);
    }
};

export const generateFileUrl = file => {
    const blob = new Blob([file]);
    const fileUrl = URL.createObjectURL(blob);
    return fileUrl;
};

const isMinioUrl = url => {
    return url.includes("s3.stepforma.app");
};

const createMinioLink = async (fileName, fileUrl) => {
    try {
        const res = await fetch(fileUrl);
        if (!res.ok) throw new Error("Network response was not ok");

        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        window.URL.revokeObjectURL(url);
    } catch (err) {
        console.error("Erro ao baixar o arquivo:", err);
    }
};

const createNormalLink = (fileName, fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", fileName);

    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
};
